import { IORGDataTableQueryState } from 'shared-it-appmod-ui';
import { httpClient } from 'src/libraries/http.library';
import {
  FireDispatchListSchema,
  FireDispatchFiltersSchema,
  FireDispatchReportListSchema,
} from 'src/models/fire-dispatch.model';
import {
  FireDispatchHelicopterCompanySchema,
  FireAgencySchema,
  IFireDispatch,
  FireDispatchDetailsSchema,
  FireDispatchSavedShchema,
} from 'src/models/fire-fighting-dispatch.model';

const http = httpClient();

const services = {
  filterGET: async () => {
    return http.get('/requestFilters', {}, FireDispatchFiltersSchema);
  },

  listGET: async (data: Partial<IORGDataTableQueryState> = {}) => {
    const params: Record<string, any> = {
      ...data,
    };
    if (params.order) {
      params.order = params.order === 'ascending' ? 'asc' : 'desc';
    }
    return http.get('/fireDispatch', params, FireDispatchListSchema);
  },

  reportListGET: async (data: Partial<IORGDataTableQueryState> = {}) => {
    const params: Record<string, any> = {
      ...data,
    };
    if (params.order) {
      params.order = params.order === 'ascending' ? 'asc' : 'desc';
    }
    return http.get(
      '/FireDispatchReport',
      params,
      FireDispatchReportListSchema
    );
  },

  getHelicopterCompanyData: async () => {
    return http.get(
      'operators',
      { limit: 0, dispatchFlag: true },
      FireDispatchHelicopterCompanySchema
    );
  },
  getFireAgencyData: async () => {
    return http.get('fireAgencies', { limit: 0 }, FireAgencySchema);
  },
  saveFireDispatchData: async (
    data: Partial<IFireDispatch>,
    dispatchId?: number
  ) => {
    if (Number(dispatchId) > 0) {
      return http.put(
        `fireDispatch/${dispatchId}`,
        { ...data },
        FireDispatchSavedShchema
      );
    }
    return http.post('fireDispatch', { ...data }, FireDispatchSavedShchema);
  },
  createFireDispatchPOST: async (data: Partial<IFireDispatch>) => {
    return http.post('fireDispatch', data, FireDispatchSavedShchema);
  },
  getFireDispatchDetailsData: async (dispatchId: number) => {
    return http.get('fireDispatch', { dispatchId }, FireDispatchDetailsSchema);
  },
};

export default services;
